import store from '@/state/store'

export default [
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('./view/wwwroot/index'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./view/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['authentication/loggedIn']) {
                    next({name: 'default'})
                } else {
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('./view/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['authentication/loggedIn']) {
                    next({name: 'default'})
                } else {
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: () => import('./view/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['authentication/loggedIn']) {
                    next({name: 'default'})
                } else {
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                store.dispatch('authentication/logout')
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                next(authRequiredOnPreviousRoute ? {name: 'default'} : {...routeFrom})
            },
        },
    },
    {
        path: '/404',
        component: () => import('./view/404'),
    },
    {
        path: '*',
        redirect: '/404'
    }
]
